import cx from "classnames";
import { Fragment } from "react";

import { StatsBlock as StatsBlockType } from "../../types";
import MarkdownText from "../helper/MarkdownText";

import styles from "../../styles/StatsBlock.module.less";

type StatsBlockProps = {
  className: string;
  block: StatsBlockType;
};

const StatsBlock = ({ block, className }: StatsBlockProps) => {
  return (
    <ul className={cx(styles.container, className)}>
      {block.stats.map((stat, index) => (
        <Fragment key={stat.value}>
          {!!index && <div className={styles.divider} />}
          <li className={styles.stat} key={stat.value}>
            {stat.value && (
              <p className={styles.value}>
                <MarkdownText value={stat.value} />
              </p>
            )}
            {stat.description && (
              <p className={styles.label}>
                <MarkdownText value={stat.description} />
              </p>
            )}
          </li>
        </Fragment>
      ))}
    </ul>
  );
};

export default StatsBlock;
